import type { OptionItem, GenerationData } from "@/types/generation.types";

/**
 * 獲取所有學制選項
 */
export const getEduOptions = (data: GenerationData): OptionItem[] => {
  return data.eduContent;
};

/**
 * 根據學制獲取科目選項
 */
export const getSubjectsByEdu = (
  data: GenerationData,
  eduCode: string | null
): OptionItem[] => {
  if (!eduCode) return [];
  return data.subjectContent[eduCode] || [];
};

/**
 * 根據科目獲取冊次選項
 */
export const getVolumesBySubject = (
  data: GenerationData,
  subjectCode: string | null
): OptionItem[] => {
  if (!subjectCode) return [];
  return data.volumeContent[subjectCode] || [];
};

/**
 * 根據科目和冊次獲取章節選項
 */
export const getChaptersByVolume = (
  data: GenerationData,
  subjectCode: string | null,
  volumeCode: string | null
): OptionItem[] => {
  if (!subjectCode || !volumeCode) return [];
  const key = `${subjectCode}_${volumeCode}`;
  return data.chapterContent[key] || [];
};

/**
 * 根據科目、冊次和章節獲取小節選項
 */
export const getSubChaptersByChapter = (
  data: GenerationData,
  subjectCode: string | null,
  volumeCode: string | null,
  chapterCode: string | null
): OptionItem[] => {
  if (!subjectCode || !volumeCode || !chapterCode) return [];
  const key = `${subjectCode}_${volumeCode}_${chapterCode}`;
  return data.subChapterContent[key] || [];
};

export const getSubjectCodeWithoutEdu = (subjectCode: string): string => {
  if (!subjectCode) return "";

  return subjectCode.slice(1);
};

export const pickValidOption = (value: string | null, options: OptionItem[]) =>
  options.some((option) => option.code === value)
    ? value
    : options[0]?.code ?? null;
